export const launchUpskill = (brandId, params) => {

    Utils.windowOpener(new Promise(async (resolve, reject) => {
        try {
            let url = await HarriUpskillIntegrationAPI.getUpskillLaunchLink(brandId, params);
            resolve(url);
        } catch (err) {
            const errMSG = err?.data?.errors?.length ? getUpskillErrorMessage(err.data.errors[0].code) : getUpskillErrorMessage();
            Utils.hConfirm({
                title: "",
                text: errMSG,
                confirmButton: $filter('translate')("Okay"),
                cancelButtonClass: 'hidden',
            });
            reject(err)
        }
    }));
}

const getUpskillErrorMessage = (errCode) => {
    let errMsg;
    switch (errCode) {
        case 'UNMAPPED_LEARNER_EXCEPTION':
            errMsg = $filter("translate")('Upskill has not yet registered the account. Will be resolved soon');
            break;
        case HARRI_UPSKILL_INTEGRATION_ERROR_CODES.INSUFFICIENT_CREDENTIALS:
            errMsg = $filter('translate')('Your credentials are insufficient, and we are unable to log you in to Upskill via SSO.');
            break;
        default:
            errMsg = $filter("translate")('Something went wrong') + '!';
    }
    return errMsg;
}